// extracted by mini-css-extract-plugin
module.exports = {"badge":"widget-demo--badge--1g_f_","count":"widget-demo--count--2hnIP","tooltip":"widget-demo--tooltip--1mzjs","tooltipText":"widget-demo--tooltipText--233C6"};